<!-- linkLabel="{{ 'auth.login.view_forgot_password' | translate }}" -->
<lib-auth-container headerTXT="{{ 'auth.login.view_title' | translate }}"
  btnLabel="{{ 'auth.login.view_login_button' | translate }}" (btnClick)="login()" [(loading)]="isLoading"
  linkLabel="¿Olvidaste tu contraseña?" (linkClick)="forgotPassword()" [redirecting]="redirecting()">
  <form [formGroup]="loginForm">
    <label for="username" class="font-normal px-1 !text-gray-500" hlmLabel>{{
      'auth.login.view_user_label' | translate
      }}</label>
    <input id="username" class="w-full !py-2" hlmInput formControlName="username" required
      [placeholder]="'auth.login.view_user_placeholder' | translate" (keydown.enter)="login()" />
    @if ( hasError("username", "required") ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.login.error_required_username' | translate }}
    </p>
    } @if ( accessErrorExists ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.errors.access_error' | translate }}
    </p>
    }

    <br />
    <label for="password" class="font-normal px-1 !text-gray-500" hlmLabel>{{
      'auth.login.view_password_label' | translate
      }}</label>
    <div class="w-full relative">
      <input #pwdInpt id="password" class="w-full !py-2" hlmInput type="password" formControlName="password" required
        [placeholder]="'auth.login.view_password_placeholder' | translate" (keydown.enter)="login()" />
      @if(pwdInpt.type === "password") {
      <hlm-icon name="lucideEye" (click)="pwdInpt.type = 'text'" color="gray" size="sm"
        class="absolute opacity-70 z-50 top-[50%] -translate-y-1/2 right-3"></hlm-icon>
      } @else {
      <hlm-icon name="lucideEyeOff" (click)="pwdInpt.type = 'password'" color="gray" size="sm"
        class="absolute opacity-70 z-50 top-[50%] -translate-y-1/2 right-3"></hlm-icon>
      }
    </div>
    @if ( hasError("password", "required") ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.login.error_required_password' | translate }}
    </p>
    } @if ( accessErrorExists ) {
    <p class="text-red-500 px-2 text-sm pt-1">
      {{ 'auth.errors.access_error' | translate }}
    </p>
    }
  </form>
</lib-auth-container>
